export enum OrganizationRoles {
  Suspended = 0,
  Viewer = 1,
  User = 3,
  Admin = 5,
  Owner = 7,
}

// TODO: Add only for Mates
export enum OrganizationStatuses {
  Initializing = 'initializing',
  Onboarding = 'onboarding',
  Ready = 'ready',
}
